import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-modal-opciones-asignacion',
  templateUrl: './modal-opciones-asignacion.component.html',
  styleUrls: ['./modal-opciones-asignacion.component.scss']
})
export class ModalOpcionesAsignacionComponent implements OnInit {

  @ViewChild('modalOpcionesAsignacion', { static: true }) modalOpcionesAsignacion: ModalDirective

  // Input
  @Input() title: String = ""
  @Input() contentText: String = ""
  @Input() asignarButtonText: String = "Asignar"
  @Input() reagsinarButtonText: String = "Reasignar"
  @Input() cancelButtonText: String = "Cancelar"

  // Output
  @Output() onAsignar: EventEmitter<any> = new EventEmitter<any>();
  @Output() onReasignar: EventEmitter<any> = new EventEmitter<any>();
  @Output() onLiberar: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();

  loading = false;
  // Callbacks
  private asignarCallback: Function;
  private reasignarCallback: Function;
  private liberarCallback: Function;
  private cancelCallback: Function;
  processing: boolean = false
  Asignado: boolean = false

  constructor() { }

  ngOnInit() {
  }

  /********* SHOW/HIDE *********/
  show(asignarCallback: Function = null, reasignarCallback: Function = null,  liberarCallback: Function = null,  cancelCallback: Function = null) {
    this.asignarCallback = asignarCallback
    this.reasignarCallback = reasignarCallback
    this.liberarCallback = liberarCallback
    this.cancelCallback = cancelCallback
    this.modalOpcionesAsignacion.show();
  }

  showWithInlineConfig(title: string, contentText: string, isAsignar:boolean, asignarCallback: Function = null, reasignarCallback: Function = null,  liberarCallback: Function = null, cancelCallback: Function = null) {
    this.title = title
    this.contentText = contentText
    this.Asignado = isAsignar
    this.asignarCallback = asignarCallback
    this.reasignarCallback = reasignarCallback
    this.liberarCallback = liberarCallback
    this.cancelCallback = cancelCallback
    this.modalOpcionesAsignacion.show();
  }

  hide() {
    this.modalOpcionesAsignacion.hide();
    return new Promise(resolve => {
      setTimeout(() => {

        this.processing = false;
      }, 1000);
    });
    //this.processing = false

  }
  /********* SHOW/HIDE *********/

  /********* OPERATIONS *********/
  async asignar() {
    this.processing = true
    if (this.asignarCallback) {

      this.asignarCallback()
    }
    console.log("Asignar")
    this.onAsignar.emit();
    await this.hide();
  }

  async reasignar() {
    this.processing = true
    if (this.reasignarCallback) {

      this.reasignarCallback()
    }
    console.log("Carga")
    this.onAsignar.emit();
    await this.hide();
  }

  async liberar() {
    this.processing = true
    if (this.liberarCallback) {

      this.liberarCallback()
    }
    console.log("Carga")
    this.onAsignar.emit();
    await this.hide();
  }


  cancel() {
    if (this.cancelCallback)
      this.cancelCallback()
    this.onCancel.emit();
    this.hide()
  }
  /********* OPERATIONS *********/

}
